import { Component, OnInit, Output, EventEmitter, Input} from '@angular/core';
import { GridAction, Action } from '../../base-types';

@Component({
  selector: 'app-fab-button-set',
  templateUrl: './fab-button-set.component.html',
  styleUrls: ['./fab-button-set.component.scss']
})
export class FabButtonSetComponent {

  _secondaryActions: Action[];
  @Input() set secondaryActions(secondaryActions: Action[]) {
    console.log('secondaryAction :>> ', JSON.stringify(secondaryActions));
    this._secondaryActions = secondaryActions;
  }
  get secondaryActions() {
    return this._secondaryActions;
  }
  _primaryAction: Action;

  @Input() set primaryAction(primaryAction: Action) {
    this._primaryAction = primaryAction;
  }
  get primaryAction() {
    return this._primaryAction;
  }

  @Output() buttonClick: EventEmitter<string> = new EventEmitter<string>();

  constructor() { }

  click(actionId?){
    this.buttonClick.emit(actionId)
  }
}
